/**
 * EyebrowBadge — small cyan pill with animated dot, used above hero/section titles.
 *
 * @spec /doc/specs/frontend/design-system/design-tokens-v2.md
 * @userStory US-EP022-010
 */

import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface EyebrowBadgeProps {
  children: ReactNode;
  className?: string;
}

export function EyebrowBadge({ children, className }: EyebrowBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-xs font-medium uppercase tracking-wider',
        'border border-cyan-500/20 bg-cyan-500/10 text-cyan-300',
        className
      )}
    >
      <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-cyan-500" aria-hidden="true" />
      {children}
    </span>
  );
}
